<template>
	<div class="p-3">
		<gift-goal-settings-content />
	</div>
</template>

<script>
import GiftGoalSettingsContent from '@/components/Widget/GiftGoalSettingsContent.vue';

export default {
	components: { GiftGoalSettingsContent },
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
		}
	},
};
</script>

<style>
html, body, #app {
	margin: 0;
	padding: 0;
}
</style>
